/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { IGetSocialNetworkSuccess, IGetSocialNetworkFailure } from "./SocialNetworkAction";
import {
  SOCIALNETWORKDATA_LOAD_SUCCESS,
  SOCIALNETWORKDATA_LOAD_FAILURE,
} from "./SocialNetworkActionTypes";
import { ISocialNetworkDataState } from "../../Interfaces/SiteContent";

const initialState: ISocialNetworkDataState = {
  socialNetworks: [],
  socialNetworkOptionList: [],
  socialNetworkLoadError: "",
};

/**
 *
 * @param state
 * @param action
 */
const applyLoadSocialNetworks = (
  state: ISocialNetworkDataState,
  action: IGetSocialNetworkSuccess
): ISocialNetworkDataState => ({
  ...state,
  socialNetworks: action.socialNetworks,
  socialNetworkOptionList: action.socialNetworks.map((x) => ({
    key: x.socialNetworkName,
    text: x.socialNetworkName,
    id: x.socialNetworkId,
    urlPrefix: x.socialNetworkUrlPrefix,
  })),
});

/**
 *
 * @param state
 * @param action
 */
const applyLoadFailSocialNetworks = (
  state: ISocialNetworkDataState,
  action: IGetSocialNetworkFailure
): ISocialNetworkDataState => ({
  ...state,
  socialNetworkLoadError: action.socialNetworkLoadError,
});

/**
 *
 * @param state
 * @param action
 */
function socialNetworkReducer(state: ISocialNetworkDataState = initialState, action) {
  switch (action.type) {
    case SOCIALNETWORKDATA_LOAD_SUCCESS:
      return applyLoadSocialNetworks(state, action);
    case SOCIALNETWORKDATA_LOAD_FAILURE:
      return applyLoadFailSocialNetworks(state, action);
    default:
      return state;
  }
}

export default socialNetworkReducer;
